<div class="media">
    <div class="header">
          <p style="font-family: verdana; text-align: center; margin-top:20px;"><b>OUR PHOTO GALLERY</b></p>
    </div>
    <div class="divider"></div>

    <div class="media-section">
          <p class="media-header">Timket</p>
            <div class="media-container">
                <div class="img-container">
                    <img src="./assets/two.jpg"/>
                </div>
                <div class="img-container">
                    <img src="./assets/two.jpg"/>
                </div>
                <div class="img-container">
                    <img src="./assets/two.jpg"/>
                </div>
                <div class="img-container">
                    <img src="./assets/two.jpg"/>
                </div>
                <div class="img-container">
                    <img src="./assets/two.jpg"/>
                </div>
              </div>
    </div>

    <div class="media-section">
        <p class="media-header">Wedding</p>
          <div class="media-container">
              <div class="img-container">
                  <img src="./assets/two.jpg"/>
              </div>
              <div class="img-container">
                  <img src="./assets/two.jpg"/>
              </div>
              <div class="img-container">
                  <img src="./assets/two.jpg"/>
              </div>
              <div class="img-container">
                  <img src="./assets/two.jpg"/>
              </div>
              <div class="img-container">
                  <img src="./assets/two.jpg"/>
              </div>
            </div>
  </div>

  <div class="media-section">
    <p class="media-header">Baptism</p>
      <div class="media-container">
          <div class="img-container">
              <img src="./assets/two.jpg"/>
          </div>
          <div class="img-container">
              <img src="./assets/two.jpg"/>
          </div>
          <div class="img-container">
              <img src="./assets/two.jpg"/>
          </div>
          <div class="img-container">
              <img src="./assets/two.jpg"/>
          </div>
          <div class="img-container">
              <img src="./assets/two.jpg"/>
          </div>
        </div>
</div>


   
   
   
  
</div>
